import React, { useEffect } from "react"
import "twin.macro"
import { useTranslation } from "next-i18next"
import { Container } from "../../page/gridContainer"
import { ReactComponent as Logo } from "../../../assets/icons/bonsai_logo.svg"
import { Events, registerEvent } from "../../../analytics"

export const QuestionFlagged = () => {
  const { t } = useTranslation("question")
  useEffect(() => {
    registerEvent(Events.VisitedFlaggedQuestion)
  }, [])
  return (
    <section tw="py-8 mb-12 h-full">
      <Container>
        <div tw="grid grid-cols-4 tablet:grid-cols-12 gap-4 desktop:gap-6 gap-y-4">
          <div tw="col-span-4 tablet:(col-span-6 col-start-4) tablet-lg:(col-span-8 col-start-3) flex flex-col items-center text-center space-y-8">
            <h1 tw="title-4 pt-4">{t("open.is_flagged")}</h1>
            <Logo />
          </div>
        </div>
      </Container>
    </section>
  )
}
